export default "https://cdn-static.gokick.com/assets/b11b69440b74c450e5ca5f7ba176f3cdc3a0fffe/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";